<template>
<!--    <div class="d-flex flex-column justify-content-center align-items-center center-box" id="center-box">-->
    <div class="center-box d-flex flex-column justify-content-center" id="center-box">
        <div v-if="!noPermission">
            <slot/>
        </div>
        <div v-else>
            <h3 class="error-text">Permission Denied</h3>
            <p>You don't have permission to access this page, please try other pages or contact your administrator.</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "CenterBox",
    data(){
        return{
            noPermission: false,
        }
    },
    props: {
        pageID: '',
        otherPer: [],
    },
    watch: {
        'pageID': {
            async handler(getData) {
                await this.startToCheck()
            },
        },
    },
    methods: {
        async startToCheck(){
            if(this.$store.state.isAuthenticated === false){
                if(this.$router.currentRoute._value.name === 'system-license'){
                    // pass
                }else{
                    this.$router.push('/login')
                }
            }else{
                this.noPermission = false
                if(this.pageID && this.pageID !== 0){
                    // 1. Check Page access
                    let pagePermission = await this.$permissionCheck(this.pageID)
                    if(pagePermission.status === 0){
                        this.noPermission = true
                    }else{
                        this.noPermission = false
                        this.$emit('permissionData', pagePermission.details)
                    }
                }
            }
        }
    },
    mounted() {
        this.startToCheck()
    }
}
</script>

<style scoped>
.center-box{
    background-color: white;
    border: solid #c5c5c5 3px;
    border-radius: 30px;
    height: auto;
    padding: 1%;
    width: 50%;
    margin: auto;

    /*position: absolute;*/
    /*top: 50%;*/
    /*left: 50%;*/
    /*-moz-transform: translateX(-50%) translateY(-50%);*/
    /*-webkit-transform: translateX(-50%) translateY(-50%);*/
    /*transform: translateX(-50%) translateY(-50%);*/
}

@media screen and (min-width : 0px) and (max-width : 1023px){
    .center-box{
        width: 97%;
    }
}

</style>
